import get from 'lodash/get';
import BaseComponent from 'foundation/base-component';
import gtm from 'general/js/gtm';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import store from 'general/js/store';

class LiveVideoWidget extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.unsubscribe = null;
        this.state = {
            isLive: this.options.isLive,
            title: null,
        };

        this.init();
    }

    static getRequiredRefs() {
        return ['title'];
    }

    init() {
        this.element.addEventListener('click', this.onRootClick);
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        this.unsubscribe = store.subscribe(this.onStoreUpdate);
    }

    onDestroy() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        this.unsubscribe();
    }

    onRootClick = () => {
        const { title } = this.state;

        if (title) {
            gtm.push('Live Video', 'Play Video', title);
        }
    }

    onStoreUpdate = () => {
        const state = store.getState();
        const config = get(state, 'scoring.liveScanner.liveVideoWidget');

        if (!config) return;

        if (this.state.isLive !== config.isLive) {
            if (config.isLive) {
                this.element.classList.add('is-live');
            } else {
                this.element.classList.remove('is-live');
            }
            this.element.href = config.pageUrl;
            this.element.style.backgroundImage = `url(${config.imageUrl})`;
            this.refs.title.innerHTML = config.title;
            this.refs.partner.src = config.partnersLogoUrl ? config.partnersLogoUrl : "";
            this.state.title = config.title;
            this.state.isLive = config.isLive;
        }
    }
}

export default LiveVideoWidget;
